export default {
    list: {
        title: 'Articles',
        newArticle: 'New article',
        searchPlaceholder: 'Search by title, excerpt or tag…',
        allTags: 'All tags',
        empty: 'No articles match these filters.',
        columns: {
            tags: 'Tags',
            published: 'Published',
        },
        count: 'no articles | {n} article | {n} articles',
        perPage: 'per page',
        pageOf: 'Page {page} of {pages}',
    },
    status: {
        scheduled: 'Scheduled',
        live: 'Live',
    },
    edit: {
        newTitle: 'New article',
        created: 'Article created',
        confirmDelete: 'Delete article "{title}"? This cannot be undone.',
        content: 'Content',
        slugHint: 'URL segment; auto-derived from title if blank',
        excerpt: 'Excerpt',
        excerptHint: 'Short summary for listings + meta description',
        translations: 'Translations',
        defaultLocale: '(default)',
        defaultLocaleNote: "The default locale uses the Title / Excerpt above. The Body tab edits this locale's body.",
        fallbackNote: 'Leave a field blank to fall back to the default-locale text.',
        body: 'Body',
        editingLocale: 'Editing {locale}. Blank = fall back to default-locale body.',
        searchEngines: 'Search engines',
        seoIntro: 'Leave a field blank to use the default: the article title for the title, its excerpt for the meta description.',
        pageTitle: 'Page title',
        pageTitleHint: 'Shown as the browser tab and the search result headline',
        metaDescription: 'Meta description',
        metaDescriptionHint: 'Optimal length is 120 to 158 characters',
        socialTitle: 'Social title',
        socialTitleHint: 'Open Graph title used when the article is shared',
        socialDescription: 'Social description',
        advanced: 'Advanced',
        socialImage: 'Social image',
        socialImageHint: 'Blank = the featured image',
        canonicalOverride: 'Canonical override',
        robots: 'Robots',
        robotsHintNoindex: 'The website is hidden from search engines, so this article sends noindex,nofollow whatever is set here. Change it in Website → General → Search engines.',
        robotsHint: 'Blank = the website default (index,follow). A noindex article is also left out of the sitemap.',
        publishing: 'Publishing',
        publishingNote: 'An article goes live when published and its publish date has passed. Set a future date to schedule it.',
        publishDate: 'Publish date',
        author: 'Author',
        authorHint: 'Shown as the byline',
        access: 'Access',
        featuredImage: 'Featured image',
        replaceImage: 'Replace',
        chooseImage: 'Choose image',
        tags: 'Tags',
        tagPlaceholder: 'Type a tag and press Enter…',
        pickImage: 'Pick or upload an image',
    },
};
